import React from 'react'

function BlogDetails() {
    return (
        <>
            <div>
                {/* header-area */}
                <header id="header">
                    <div id="sticky-header" className="menu-area menu-style-two transparent-header">
                        <div className="container custom-container-three">
                            <div className="row">
                                <div className="col-12">
                                    <div className="mobile-nav-toggler"><i className="fas fa-bars" /></div>
                                    <div className="menu-wrap">
                                        <nav className="menu-nav">
                                            <div className="logo">
                                                <a href="/"><img src="assets/img/logo/logo.png" alt /></a>
                                            </div>
                                            <div className="navbar-wrap main-menu d-none d-lg-flex">
                                                <ul className="navigation">
                                                    <li className="menu-item-has-children"><a href="#header">Home</a>
                                                        <ul className="sub-menu">
                                                            <li><a href="/">Home One</a></li>
                                                            <li><a href="/index">Home Two</a></li>
                                                        </ul>
                                                    </li>
                                                    <li><a href="/#about">About us</a></li>
                                                    <li><a href="/#sales">Sales</a></li>
                                                    <li><a href="/#roadmap">Roadmap</a></li>
                                                    <li className="active menu-item-has-children"><a href="/blog">Blog</a>
                                                        <ul className="sub-menu">
                                                            <li><a href="/blog">Our Blog</a></li>
                                                            <li className="active"><a href="/blog-details">Blog Details</a></li>
                                                        </ul>
                                                    </li>
                                                    <li><a href="/#contact">Contact us</a></li>
                                                </ul>
                                            </div>
                                            <div className="header-action d-none d-md-block">
                                                <ul>
                                                    <li className="header-lang"><span className="selected-lang">ENG</span>
                                                        <ul className="lang-list">
                                                            <li><a href="#">IND</a></li>
                                                            <li><a href="#">BNG</a></li>
                                                            <li><a href="#">TUR</a></li>
                                                            <li><a href="#">CIN</a></li>
                                                        </ul>
                                                    </li>
                                                    <li className="header-btn"><a href="#" className="btn">Buy Now</a></li>
                                                </ul>
                                            </div>
                                        </nav>
                                    </div>
                                    {/* Mobile Menu  */}
                                    <div className="mobile-menu">
                                        <nav className="menu-box">
                                            <div className="close-btn"><i className="fas fa-times" /></div>
                                            <div className="nav-logo"><a href="/"><img src="assets/img/logo/logo.png" alt title /></a>
                                            </div>
                                            <div className="menu-outer">
                                                {/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}
                                            </div>
                                            <div className="social-links">
                                                <ul className="clearfix">
                                                    <li><a href="#"><i className="fab fa-facebook-f" /></a></li>
                                                    <li><a href="#"><i className="fab fa-twitter" /></a></li>
                                                    <li><a href="#"><i className="fab fa-instagram" /></a></li>
                                                    <li><a href="#"><i className="fab fa-linkedin-in" /></a></li>
                                                    <li><a href="#"><i className="fab fa-youtube" /></a></li>
                                                </ul>
                                            </div>
                                        </nav>
                                    </div>
                                    <div className="menu-backdrop" />
                                    {/* End Mobile Menu */}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                {/* header-area-end */}
                {/* main-area */}
                <main>
                    {/* breadcrumb-area */}
                    <section className="breadcrumb-area breadcrumb-bg">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8">
                                    <div className="breadcrumb-content">
                                        <h2 className="title">Single Article</h2>
                                        <nav aria-label="Breadcrumbs">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/"><span>Home</span></a>
                                                </li>
                                                <li className="breadcrumb-item"><span>Blog details</span></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* breadcrumb-area-end */}
                    {/* blog-area */}
                    <section className="blog-details-area pt-130 pb-130">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="blog-post-item blog-details-wrap">
                                        <div className="blog-post-thumb">
                                            <img src="assets/img/blog/blog_img01.jpg" alt />
                                        </div>
                                        <div className="blog-post-content">
                                            <div className="blog-meta">
                                                <ul>
                                                    <li><a href="/blog-details"><i className="far fa-user" />Alextina</a></li>
                                                    <li><i className="far fa-clock" />Dec 28, 2023</li>
                                                    <li><a href="/blog-details"><i className="fas fa-comment-dots" />(04) Comments</a></li>
                                                </ul>
                                            </div>
                                            <h2 className="title">New trends in UI/UX Design World of crypto Integration of this year</h2>
                                            <p>Laboratories used for scientific research take many forms because of the differing requirements of specialists in the various fields of science and engineering. A physics laboratory</p>
                                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, aperiam ipsquae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim voluptatem voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,</p>
                                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, aperiam ipsquae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo</p>
                                            <div className="bd-approach-wrap">
                                                <div className="row align-items-center">
                                                    <div className="col-46">
                                                        <div className="bd-approach-content">
                                                            <h4 className="title">Our Approach</h4>
                                                            <p>Must explain to you how all praising uts pain was born and I will gives you a itself completed account of the
                                                                system, and sed expounds the ut actual teachings of that greater</p>
                                                            <ul>
                                                                <li><i className="fas fa-check" />Extramural Funding</li>
                                                                <li><i className="fas fa-check" />Bacteria Markers</li>
                                                                <li><i className="fas fa-check" />Nam nec mi euismod euismod</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="col-54">
                                                        <div className="bd-approach-img">
                                                            <img src="assets/img/blog/blog_details01.jpg" alt />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="bd-technology-content">
                                                <h2 className="title">What Is A Business Technology Roadmap?</h2>
                                                <p>Unlike detailed blueprints that lay out all tasks, deadlines, bug reports, and more along the way, technology roadmaps  are high-level visual summaries highlighting a company’s vision or plans.</p>
                                                <p>In an Agile approach, a technology roadmap feeds the sprint and grooming processes, providing insight into how the product will travel from start to finish. It makes it easier for development teams to:</p>
                                            </div>
                                            <div className="blog-details-img">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <img src="assets/img/blog/blog_details02.jpg" alt />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <img src="assets/img/blog/blog_details03.jpg" alt />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="blog-details-bottom">
                                                <div className="blog-details-tags">
                                                    <ul>
                                                        <li className="tag-title">Tag</li>
                                                        <li><a href="#">Business</a></li>
                                                        <li><a href="#">Design</a></li>
                                                        <li><a href="#">apps</a></li>
                                                        <li><a href="#">data</a></li>
                                                    </ul>
                                                </div>
                                                <div className="blog-details-social">
                                                    <ul>
                                                        <li className="social-title">Share</li>
                                                        <li><a href="#"><i className="fab fa-linkedin" /></a></li>
                                                        <li><a href="#"><i className="fab fa-pinterest" /></a></li>
                                                        <li><a href="#"><i className="fab fa-facebook" /></a></li>
                                                        <li><a href="#"><i className="fab fa-twitter" /></a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comment-wrap">
                                        <h4 className="title">(04) Comment</h4>
                                        <div className="latest-comments">
                                            <ul className="list-wrap">
                                                <li>
                                                    <div className="comments-box">
                                                        <div className="comments-avatar">
                                                            <img src="assets/img/blog/comment_avatar01.png" alt />
                                                        </div>
                                                        <div className="comment-text">
                                                            <div className="avatar-name">
                                                                <h5 className="title">Kristin Watson <a href="#" className="comment-reply-link"><i className="fas fa-reply-all" /></a>
                                                                </h5>
                                                                <span>19th August 2023</span>
                                                            </div>
                                                            <p>Patient Comments are a collection of comments submitted by viewers in response to a question posed by a
                                                                MedicineNet doctor.</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <ul className="children">
                                                        <li>
                                                            <div className="comments-box">
                                                                <div className="comments-avatar">
                                                                    <img src="assets/img/blog/comment_avatar02.png" alt />
                                                                </div>
                                                                <div className="comment-text">
                                                                    <div className="avatar-name">
                                                                        <h5 className="title">Brooklyn Simmons <a href="#" className="comment-reply-link"><i className="fas fa-reply-all" /></a>
                                                                        </h5>
                                                                        <span>19th August 2023</span>
                                                                    </div>
                                                                    <p>Include anecdotal examples of your experience, or things you took notice of that you feel others would find useful.</p>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="post-comments-form">
                                        <div className="post-comment-content">
                                            <h4 className="title">Leave a Reply</h4>
                                            <p>Your email address will not be published. Required fields are marked *</p>
                                        </div>
                                        <div className="comment-form">
                                            <form action="#">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-grp">
                                                            <input type="text" placeholder="Enter your Name" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-grp">
                                                            <input type="email" placeholder="Enter your email" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-grp">
                                                            <input type="text" placeholder="Enter your number" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-grp">
                                                            <input type="text" placeholder="Enter your website" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-grp">
                                                    <textarea name="comment" placeholder="Type your comment" defaultValue={""} />
                                                </div>
                                                <button type="submit" className="btn btn-two">Post comment</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <aside className="blog-sidebar">
                                        <div className="blog-widget">
                                            <h2 className="bw-title">Search Here</h2>
                                            <form action="#" className="sidebar-search">
                                                <input type="text" placeholder="Search post" />
                                                <button type="submit"><i className="fas fa-search" /></button>
                                            </form>
                                        </div>
                                        <div className="blog-widget">
                                            <h2 className="bw-title">Categories</h2>
                                            <div className="category-list">
                                                <ul>
                                                    <li><a href="#">Chemistry <span>03</span></a></li>
                                                    <li><a href="#">Forensic science <span>07</span></a></li>
                                                    <li><a href="#">Gemological <span>09</span></a></li>
                                                    <li><a href="#">Chemistry <span>01</span></a></li>
                                                    <li><a href="#">UI/UX Deisgn <span>00</span></a></li>
                                                    <li><a href="#">Gemological <span>26</span></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="blog-widget">
                                            <h2 className="bw-title">Pages</h2>
                                            <div className="page-list">
                                                <ul>
                                                    <li><a href="#">Web Design<i className="fas fa-chevron-right" /></a></li>
                                                    <li><a href="#">Branding Design<i className="fas fa-chevron-right" /></a></li>
                                                    <li><a href="#">Photography<i className="fas fa-chevron-right" /></a></li>
                                                    <li><a href="#">Business Statergy<i className="fas fa-chevron-right" /></a></li>
                                                    <li><a href="#">UI/UX Deisgn<i className="fas fa-chevron-right" /></a></li>
                                                    <li><a href="#">Web Development<i className="fas fa-chevron-right" /></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="blog-widget">
                                            <h2 className="bw-title">Recent Post</h2>
                                            <div className="rc-post-wrap">
                                                <div className="rc-post-item">
                                                    <div className="rc-post-thumb">
                                                        <a href="/blog-details"><img src="assets/img/blog/rc_post_img01.jpg" alt /></a>
                                                    </div>
                                                    <div className="rc-post-content">
                                                        <span>4 March. 2023</span>
                                                        <h4 className="title"><a href="/blog-details">Don’t Underestimate The Software</a></h4>
                                                    </div>
                                                </div>
                                                <div className="rc-post-item">
                                                    <div className="rc-post-thumb">
                                                        <a href="/blog-details"><img src="assets/img/blog/rc_post_img02.jpg" alt /></a>
                                                    </div>
                                                    <div className="rc-post-content">
                                                        <span>4 March. 2023</span>
                                                        <h4 className="title"><a href="/blog-details">Designing Human-Machine Interfaces..</a></h4>
                                                    </div>
                                                </div>
                                                <div className="rc-post-item">
                                                    <div className="rc-post-thumb">
                                                        <a href="/blog-details"><img src="assets/img/blog/rc_post_img03.jpg" alt /></a>
                                                    </div>
                                                    <div className="rc-post-content">
                                                        <span>4 March. 2023</span>
                                                        <h4 className="title"><a href="/blog-details">Web Design Done Well: Excellent</a></h4>
                                                    </div>
                                                </div>
                                                <div className="rc-post-item">
                                                    <div className="rc-post-thumb">
                                                        <a href="/blog-details"><img src="assets/img/blog/rc_post_img04.jpg" alt /></a>
                                                    </div>
                                                    <div className="rc-post-content">
                                                        <span>4 March. 2023</span>
                                                        <h4 className="title"><a href="/blog-details">Don’t Underestimate The Software</a></h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="blog-widget">
                                            <h2 className="bw-title">Popular Tag</h2>
                                            <div className="tag-list">
                                                <ul>
                                                    <li><a href="#">landing</a></li>
                                                    <li><a href="#">Charity</a></li>
                                                    <li><a href="#">apps</a></li>
                                                    <li><a href="#">Education</a></li>
                                                    <li><a href="#">data</a></li>
                                                    <li><a href="#">book</a></li>
                                                    <li><a href="#">Design</a></li>
                                                    <li><a href="#">website</a></li>
                                                    <li><a href="#">landing page</a></li>
                                                    <li><a href="#">data</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </aside>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* blog-area-end */}
                </main>
                {/* main-area-end */}
                {/* footer-area */}
                <footer>
                    <div className="footer-area-three footer-bg">
                        <div className="container">
                            <div className="footer-top">
                                <div className="row">
                                    <div className="col-xl-3 col-lg-4 col-md-6">
                                        <div className="footer-widget">
                                            <a href="/" className="f-logo"><img src="assets/img/logo/logo.png" alt /></a>
                                            <div className="footer-content">
                                                <p>A new way to make the payments easy, reliable and 100% secure. claritatem itamconse
                                                    quat. Exerci tationulla</p>
                                                <ul className="footer-social">
                                                    <li><a href="#"><i className="fab fa-youtube" /></a></li>
                                                    <li><a href="#"><i className="fab fa-twitter" /></a></li>
                                                    <li><a href="#"><i className="fab fa-facebook-f" /></a></li>
                                                    <li><a href="#"><i className="fab fa-skype" /></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-5 col-sm-6">
                                        <div className="footer-widget">
                                            <h4 className="fw-title">Usefull Links</h4>
                                            <div className="footer-link">
                                                <ul>
                                                    <li><a href="#">Contact us</a></li>
                                                    <li><a href="#">How it Works</a></li>
                                                    <li><a href="#">Create</a></li>
                                                    <li><a href="#">Explore</a></li>
                                                    <li><a href="#">Terms &amp; Services</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-2 col-lg-3 col-sm-6">
                                        <div className="footer-widget">
                                            <h4 className="fw-title">Community</h4>
                                            <div className="footer-link">
                                                <ul>
                                                    <li><a href="#">Help Center</a></li>
                                                    <li><a href="#">Partners</a></li>
                                                    <li><a href="#">Suggestions</a></li>
                                                    <li><a href="#">Blog</a></li>
                                                    <li><a href="#">Newsletters</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6">
                                        <div className="footer-widget">
                                            <h4 className="fw-title">Subscribe Newsletter</h4>
                                            <div className="footer-newsletter">
                                                <p>Exerci tation ullamcorper suscipit lobortis nisl aliquip ex ea commodo</p>
                                                <form action="#">
                                                    <input type="email" placeholder="Info@gmail.com" />
                                                    <button type="submit"><i className="fas fa-paper-plane" /></button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="footer-bottom">
                                <div className="row align-items-center">
                                    <div className="col-lg-6">
                                        <div className="copyright-text">
                                            <p>© Copyright 2023 Bigtech. All Rights Reserved Copyright</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="footer-menu">
                                            <ul>
                                                <li><a href="#">Terms and conditions</a></li>
                                                <li><a href="#">Privacy policy</a></li>
                                                <li><a href="#">Login / Signup</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                {/* footer-area-end */}
            </div>
        </>
    )
}

export default BlogDetails